// Hook central: carga las unidades de negocio dinámicas desde /api/business-units.
// Reemplaza los slugs hardcodeados por un catálogo persistente y configurable.
// Mantiene fallback a las 3 unidades históricas si el backend no responde.

import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../App";
import { UNIDADES as FALLBACK_UNIDADES } from "../lib/unidades";

let _cache = null;
let _cachePromise = null;

const fetchOnce = async () => {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;
  _cachePromise = axios
    .get(`${API}/business-units`, { withCredentials: true })
    .then(({ data }) => {
      _cache = {
        unidades: data.unidades || [],
        puede_ver_vista_general: data.puede_ver_vista_general || false,
        es_admin: data.es_admin || false,
        unidades_asignadas: data.unidades_asignadas || [],
      };
      return _cache;
    })
    .catch(() => {
      // Iter132 · Seguridad · No sustituir por FALLBACK_UNIDADES ni conceder
      // permisos por defecto cuando la carga falla (p. ej. sesión cerrada o
      // 401). Devolver una lista vacía y sin permisos evita filtraciones de
      // unidades/vista general antes de que el frontend re-autentique.
      _cache = {
        unidades: [],
        puede_ver_vista_general: false,
        es_admin: false,
        unidades_asignadas: [],
      };
      return _cache;
    })
    .finally(() => {
      _cachePromise = null;
    });
  return _cachePromise;
};

export const invalidarUnidadesCache = () => {
  _cache = null;
  _cachePromise = null;
};

export const useBusinessUnits = () => {
  const [state, setState] = useState(_cache || null);
  const [loading, setLoading] = useState(!_cache);

  const reload = useCallback(async () => {
    invalidarUnidadesCache();
    setLoading(true);
    const data = await fetchOnce();
    setState(data);
    setLoading(false);
    return data;
  }, []);

  useEffect(() => {
    let mounted = true;
    if (!_cache) {
      fetchOnce().then(d => {
        if (mounted) {
          setState(d);
          setLoading(false);
        }
      });
    } else {
      setState(_cache);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, []);

  return {
    unidades: state?.unidades || [],
    puedeVerVistaGeneral: state?.puede_ver_vista_general || false,
    esAdmin: state?.es_admin || false,
    unidadesAsignadas: state?.unidades_asignadas || [],
    loading,
    reload,
  };
};

// Utilidad: dado un evento, devuelve los slugs de unidades relevantes
export const unidadesDelEvento = (evento) => {
  if (!evento) return [];
  if (Array.isArray(evento.unidades) && evento.unidades.length) return evento.unidades;
  return [];
};
